<template>
  <div id="fixed-container" class="text-center hidden-sm hidden-xs fixed-container" >
    <div class="fiexed-header"></div>
    <div class="fixed-item-a" id="backToTop" v-show="backToTop" style="cursor: pointer">
      <a @click="backToTopFun()">
        <img src="https://dao-library.54traveler.com/dcr-common/menu/goTop-red.png">
      </a>
    </div>
    <div class="fixed-item-a" v-on:mouseleave="fixTelephoneFun(false)"  v-on:mouseover="fixTelephoneFun(true)" >
      <div class="tag" v-show="fixTelephone">
        <div class="arrow" data-v-a5d53fc8="">
          <em></em>
          <span></span>
        </div>
        <div style="position:relative;margin-top:15px;text-align:left;margin-left:28px">国内：400-054-8066<br>海外：86-21-60555768<br>周一至周日 9:30-18:00</div>
      </div>
      <img src="https://dao-library.54traveler.com/dcr-common/menu/telephone-red.png">
    </div>
    <div class="fixed-item-a" v-on:mouseleave="fixEwmFun(false)"   v-on:mouseover="fixEwmFun(true)">
      <div class="tag-code" v-show="fixEwm">
        <div class="arrow">
          <em></em>
          <span></span>
        </div>
        <div style="position: relative;padding: 10px;">
          <img src='https://dao-library.54traveler.com/dcr-common/code/dcr-pc-code.png' style='width:180px;height:227px;'>
        </div>
      </div>
      <img src="https://dao-library.54traveler.com/dcr-common/menu/scanCode-red.png">
    </div>
    <div class="fixed-item-a" v-on:mouseleave="fixEwmother(false)"   v-on:mouseover="fixEwmother(true)">
      <div class="tag-wxcode" v-show="fixEwmBxx">
        <div class="arrow-wxcode">
          <em></em>
          <span></span>
        </div>
        <div style="position: relative;padding: 10px;">
          <img src='https://dao-library.54traveler.com/dcr-common/code/dcr-pc-preview.png' style='width:360px;height:480px;'>
        </div>
      </div>
      <img src="https://dao-library.54traveler.com/dcr-common/menu/wxCode-red.png">
    </div>
    <div class="fiexed-footer"></div>
  </div>


</template>

<script>
  import $ from 'jquery'
  export default {
    data () {
      return {
        backToTop: false,
        fixTelephone: false,
        fixEwm: false,
        fixEwmBxx: false
      }
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      backToTopFun () {
        window.pageYOffset = 0
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      },
      fixTelephoneFun (isshow) {
        this.fixTelephone = isshow
      },
      fixEwmother (isshow) {
        this.fixEwmBxx = isshow
      },
      fixEwmFun (isshow) {
        this.fixEwm = isshow
      },
      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 500) {
          this.backToTop = true
        } else {
          this.backToTop = false
        }
      }
    },
    destroy () {
      $(window).off('scroll', this.scrollListener)
      $(this.$els.back).off('click')
    }
  }
</script>

<style>
  /* ---------------------
    ** ------ fixed --------
    */
  #fixed-container {
    position: fixed;
    right: 20px;
    bottom: 200px;
    z-index: 1000;
    color: #fff;
    background-color: #EEE;
    border-radius: 25px;
    width: 50px;
  }

  #fixed-container .fiexed-header {
    height: 20px;
    border-radius: 25px 25px 0 0;
  }
  #fixed-container .fiexed-footer {
    height: 1px;
    border-radius: 0 0 25px 25px;
  }
  #fixed-container .fixed-item-a {
    width: 33px;
    height: 33px;
    margin: 0em auto 1em;
    cursor: pointer;
  }
  #fixed-container .fixed-item-a img{
    width: 26px;
    height: 26px;
  }

  #fixed-container #fix-telephone, #fixed-container #backToTop a, #fixed-container #fix-code , #fixed-container #fix-code-wx {
    /*background-image: url("https://dao-library.54traveler.com/tour/sprites.png");*/
    /*width: 33px;*/
    /*height: 33px;*/
    /*display: inline-block;*/
    /*background-position: 0 -135px;*/
  }
  #fixed-container #backToTop a {
    background-position: 0 -178px;
  }
  #fixed-container #fix-code {
    background-position: 0 0;
  }
  #fixed-container #fix-code-wx {
    background-position: 0 -213px;
  }

  .tag {
    width:200px;
    height:100px;
    border:1px solid rgba(190, 190, 190, .7);
    position:absolute;
    border-radius: 10px;
    color: #000000;
    line-height: 24px;
    margin: -35px 0px 0px -222px;
    background-color: #FFFFFF;
  }
  .tag-code {
    width: 200px;
    height: 248px;
    border: 1px solid rgba(190, 190, 190, .7);
    position: absolute;
    border-radius: 10px;
    color: #000000;
    line-height: 24px;
    margin: -187px 0px 0px -222px;
    background-color: #FFFFFF;
  }

  .tag-wxcode {
    width: 400px;
    height: 500px;
    border: 1px solid rgba(190, 190, 190, .7);
    position: absolute;
    border-radius: 10px;
    color: #000000;
    line-height: 24px;
    background-color: #FFFFFF;
    left: -30em;
    bottom: -11em;
  }

  .arrow{ position:absolute; width:40px; height:40px; bottom:28px; left:198px;transform: rotate(272deg); }
  .arrow *{ display:block; border-width:20px; position:absolute; border-style:solid dashed dashed dashed; font-size:0; line-height:0; }
  .arrow em{border-color:lightgrey transparent transparent;}
  .arrow span{border-color:#FFF transparent transparent; top:-1px;}
  .arrow-wxcode{
    position: absolute;
    width: 40px;
    height: 40px;
    top: 283px;
    right: -40px;
    -webkit-transform: rotate(272deg);
    transform: rotate(272deg); }
  .arrow-wxcode *{ display:block; border-width:20px; position:absolute; border-style:solid dashed dashed dashed; font-size:0; line-height:0; }
  .arrow-wxcode em{border-color:lightgrey transparent transparent;}
  .arrow-wxcode span{border-color:#FFF transparent transparent; top:-1px;}
</style>



/** WEBPACK FOOTER **
 ** ScrollToTop.vue?254d8e72
 **/